import React, { Component } from "react";
import { Portal } from "react-portal";
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";

export default class ArticleThumb extends React.Component {
		
	

	render() {
		let thumb = this.props.thumb;
		if (thumb) {
			if (thumb.category) {
				
				const tags = thumb.category.map((tag,i) =>
					<li key={i} className="c-articles__thumb__tags__tag">{ tag.name }</li>
				)
			
				return (
					<div className="c-articles__thumb">
						<Link to={ thumb.permalink } className="c-articles__thumb__link">
							<div className="c-articles__thumb__image">
								<FadeIn duration={250}>
									{onload => (
										<img
											alt={thumb.title} 
											src={thumb.src} 
											srcSet={thumb.srcset} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
							</div>
							<h4 className="c-articles__thumb__heading" dangerouslySetInnerHTML={ {__html: thumb.title }}></h4>
							{tags &&
								<ul className="c-articles__thumb__tags">
									{ tags }
								</ul>
							}
						</Link>
					</div>
					
				)
			} else {
				return null;
			}
		} else {
			return null;
		}
	}
}